
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { key } from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faEye,
  faStar,
  faBell,
  faPhone,
  faCaretDown,
  faCaretUp,
  faCaretRight
} from "@fortawesome/free-solid-svg-icons";

library.add( faEye, faStar, faBell, faPhone, faCaretDown, faCaretUp, faCaretRight );

@Options( {
  components : {
    FontAwesomeIcon
  }
} )
export default class Map extends Vue
{
  store        = useStore( key );
  map_gm       = -1;
  map_el : any = null;

  mounted()
  {
    const mapboxgl = require( "mapbox-gl/dist/mapbox-gl.js" );

    let coords : any = [];

    if( this.store.state.search !== null && typeof this.store.state.search.gps !== "undefined" )
    {
      coords = [
        this.store.state.search.gps.lng,
        this.store.state.search.gps.lat
      ];
    } else
    {
      coords = [
        this.store.state.gm.gps.lng,
        this.store.state.gm.gps.lat
      ];
    }

    const map = new mapboxgl.Map( {
      container : "map",
      center    : coords,
      zoom      : 10,
      style     : "https://maps.location-gardemeuble.fr/"
    } );

    this.map_el = document.querySelector( "#map" );

    map.scrollZoom.disable();
    map.doubleClickZoom.disable();
    map.keyboard.disable();

    if( this.store.state.search !== null )
    {
      map.addControl( new mapboxgl.NavigationControl(), "top-left" );
      map.addControl( new mapboxgl.FullscreenControl(), "bottom-left" );

      for( let [index, gm] of this.store.state.search.near.entries() )
      {
        const html = document.createElement( "div" );
        html.classList.add( "gl-marker" );

        const marker = new mapboxgl.Marker( {
          element : html,
          anchor  : "bottom"
        } );
        marker.setLngLat( [gm.gps.lng, gm.gps.lat] );
        marker.addTo( map );

        marker.getElement().addEventListener( "click", ( evt : any ) => {
          this.deselect( evt );
          this.select( evt );
          this.map_gm = (this.map_gm === index ? -1 : index);

          if( this.store.getters.isMobile )
            map.flyTo( {
              center : [gm.gps.lng, gm.gps.lat],
              offset : [0, -(this.map_el.offsetHeight / 4)],
              zoom   : 10
            } );
          else
            map.flyTo( { center : [gm.gps.lng, gm.gps.lat], offset : [-(this.map_el.offsetWidth / 4), 0], zoom : 10 } );
        } );
      }

      this.store.state.search.bounds = new mapboxgl.LngLatBounds();
      this.store.state.search.bounds.extend( coords );
    }
    else
    {
      const html = document.createElement( "div" );
      html.classList.add( "gl-marker" );

      const marker = new mapboxgl.Marker( {
        element : html,
        anchor  : "bottom"
      } );
      marker.setLngLat( coords );
      marker.addTo( map );

      const bounds = new mapboxgl.LngLatBounds();
      bounds.extend( coords );

      // Disable movement
      map.dragPan.disable();
      map.dragRotate.disable();
      map.touchZoomRotate.disableRotation();
    }
  }

  deselect( evt : any )
  {
    let markers = document.querySelectorAll( ".gl-marker" );

    for( let mark of markers )
    {
      if( evt.target !== mark )
        mark.classList.remove( "active-marker" );
    }
  }

  select( evt : any )
  {
    evt.target.classList.toggle( "active-marker" );
  }
}
